/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PackageImageDTO interface.
 */
export function instanceOfPackageImageDTO(value) {
    return true;
}
export function PackageImageDTOFromJSON(json) {
    return PackageImageDTOFromJSONTyped(json, false);
}
export function PackageImageDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'uploadedAt': json['uploadedAt'] == null ? undefined : (new Date(json['uploadedAt'])),
    };
}
export function PackageImageDTOToJSON(json) {
    return PackageImageDTOToJSONTyped(json, false);
}
export function PackageImageDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'imageUrl': value['imageUrl'],
        'uploadedAt': value['uploadedAt'] == null ? undefined : ((value['uploadedAt']).toISOString()),
    };
}
